import { render } from "./UpdateEmailContainer.vue?vue&type=template&id=383d8ae0"
import script from "./UpdateEmailContainer.vue?vue&type=script&lang=js"
export * from "./UpdateEmailContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__